import { IChecklistAnswerType } from 'APIPackage/CatalogsModule/interfaces/IChecklistAnswerType';

import { IChecklistAnswerTypeSelectOption } from '../interfaces/IChecklistAnswerTypeSelectOption';

export const createChecklistAnswerTypeSelectOption = (
  checklistAnswerType: IChecklistAnswerType,
): IChecklistAnswerTypeSelectOption => ({
  ...checklistAnswerType,
  label: checklistAnswerType.name,
  value: checklistAnswerType.code,
});
